import React from 'react'
import {Modal} from '@thryvlabs/maverick'
import {useNavigate} from 'react-router'

export const AccountFailedModalComponent = ({errorMessage, onClose, onOk}) => {
  const navigate = useNavigate()
  const title = errorMessage
    ? 'Account Creation Failed'
    : 'Thanks for your patience!'
  const body = errorMessage
    ? errorMessage
    : `The system needs a few minutes.\n  Please close this screen and come back in 5 minutes to try again.`
  return (
    <>
      <Modal
        altBtn={<></>}
        openOnLoad
        variant="default"
        footer
        action
        btnAction={() => {
          onClose?.()
          onOk ? onOk() : navigate('/')
        }}
        btnActionText="Ok"
        hideX
        disableX
        disableBackdropClick
        modalClassNames="account-failed-modal"
        btnType={'primary'}
        modalTestId="account-creation-failed-modal"
      >
        <div style={{padding: '20px', textAlign: 'center'}}>
          <h3
            style={{
              color: '#FF5000',
              marginBottom: '12px',
              fontSize: '20px',
              fontWeight: '600',
            }}
          >
            {title}
          </h3>
          <p
            style={{
              whiteSpace: 'pre-wrap',
              marginTop: '16px',
              marginBottom: '0',
              color: '#333',
              fontSize: '14px',
              lineHeight: '1.6',
            }}
          >
            {body}
          </p>
        </div>
      </Modal>
    </>
  )
}
